import { keys } from './setup.js';

const STICK_DEADZONE = 0.5;

const BUTTON_MAP = [
    /* 0  A/Cross     */ 'l',
    /* 1  B/Circle    */ 'k',
    /* 2  X/Square    */ 'l',
    /* 3  Y/Triangle  */ 'k',
    /* 4  LB          */ 'e',
    /* 5  RB          */ 'shift',
    /* 6  LT          */ null,
    /* 7  RT          */ null,
    /* 8  Select/Back */ 'enter',
    /* 9  Start       */ 'space',
    /* 10 L-stick     */ null,
    /* 11 R-stick     */ null,
    /* 12 D-pad Up    */ 'w',
    /* 13 D-pad Down  */ 's',
    /* 14 D-pad Left  */ 'a',
    /* 15 D-pad Right */ 'd',
];

const gamepadHeld = new Set();
let gamepadConnected = false;

window.addEventListener('gamepadconnected', (e) => {
    gamepadConnected = true;
    console.log(`Gamepad connected: ${e.gamepad.id} (index ${e.gamepad.index})`);
});

window.addEventListener('gamepaddisconnected', (e) => {
    gamepadConnected = false;
    for (const key of gamepadHeld) {
        keys[key].pressed = false;
    }
    gamepadHeld.clear();
    console.log(`Gamepad disconnected: ${e.gamepad.id} (index ${e.gamepad.index})`);
});

export function pollGamepad() {
    if (!gamepadConnected) return;

    const gamepads = navigator.getGamepads();
    if (!gamepads) return;

    const gp = gamepads[0];
    if (!gp) return;

    const pressed = new Set();

    for (let i = 0; i < gp.buttons.length && i < BUTTON_MAP.length; i++) {
        const key = BUTTON_MAP[i];
        if (!key) continue;
        if (gp.buttons[i].pressed) {
            pressed.add(key);
        }
    }

    const lx = gp.axes[0] ?? 0;
    const ly = gp.axes[1] ?? 0;

    if (lx < -STICK_DEADZONE) pressed.add('a');
    if (lx > STICK_DEADZONE) pressed.add('d');
    if (ly < -STICK_DEADZONE) pressed.add('w');
    if (ly > STICK_DEADZONE) pressed.add('s');

    for (const key of gamepadHeld) {
        if (!pressed.has(key)) {
            keys[key].pressed = false;
            gamepadHeld.delete(key);
        }
    }

    for (const key of pressed) {
        keys[key].pressed = true;
        gamepadHeld.add(key);
    }
}
